// Forex SEO landing pages. Each page has ONE key term injected into the slug,
// header, H1, H2s, body and its tags section (20 tags + 10 search terms).

const buildTags = (k) => [
  k,
  `best ${k}`,
  `top ${k}`,
  `${k} online`,
  `${k} course`,
  `${k} program`,
  `${k} mentor`,
  `${k} academy`,
  `private ${k}`,
  `1 on 1 ${k}`,
  `professional ${k}`,
  `elite ${k}`,
  `${k} for 6 figure traders`,
  `${k} reviews`,
  `${k} near me`,
  `${k} strategy`,
  `${k} signals`,
  `${k} 2026`,
  `learn ${k}`,
  `Shabz Fazl ${k}`,
];

const buildSearchTerms = (k) => [
  `how to find a ${k}`,
  `is a ${k} worth it`,
  `best ${k} for six figure traders`,
  `${k} that actually works`,
  `how much does a ${k} cost`,
  `${k} on instagram`,
  `where to learn ${k}`,
  `${k} for consistent profits`,
  `top ${k} in 2026`,
  `${k} with Shabz Fazl`,
];

const PAGES = [
  {
    slug: "forex-trading-coach",
    key: "forex trading coach",
    img: "/forex/forex-trading-coach.jpeg",
    intro:
      "Shabz Fazl is a private forex trading coach for serious traders who are done guessing and ready to trade the currency markets with a real, repeatable edge.",
    sections: [
      { h2: "Why hire a forex trading coach", body: "Most traders don't lose because they lack information — they lose because nobody ever corrected their execution in real time. A forex trading coach watches how you actually trade the majors and shows you exactly where your process breaks under pressure." },
      { h2: "What a forex trading coach changes for you", body: "As your forex trading coach, Shabz rebuilds your playbook around clean setups, disciplined risk and a calm mindset, so consistency stops being something you force and starts being who you are at the charts." },
    ],
    learn: ["Reading the major and minor currency pairs", "Trading the London and New York sessions", "High-probability entries and exits", "Position sizing and stop discipline", "The psychology behind consistent execution"],
  },
  {
    slug: "forex-trading-mentor",
    key: "forex trading mentor",
    img: "/forex/forex-trading-mentor.jpeg",
    intro:
      "A great forex trading mentor doesn't hand you signals — she hands you the judgement to make your own calls. That is exactly what Shabz Fazl does for committed traders.",
    sections: [
      { h2: "The difference a forex trading mentor makes", body: "Self-teaching can take years of blown accounts. A forex trading mentor compresses that timeline by pointing out the mistakes you can't see yourself and holding you to a standard you'd never hold alone." },
      { h2: "Mentorship built around your trading", body: "This forex trading mentor tailors everything to your pairs, your schedule and your psychology, turning scattered effort into a focused, professional routine you can repeat for life." },
    ],
    learn: ["Building a personal trading plan", "Journaling and reviewing every trade", "Spotting and fixing recurring mistakes", "Developing patience and conviction", "Scaling size as your consistency grows"],
  },
  {
    slug: "learn-forex-trading",
    key: "learn forex trading",
    img: "/forex/learn-forex-trading.jpeg",
    intro:
      "The fastest way to learn forex trading is with direct guidance from someone who actually trades for a living — not a recycled video course. Shabz Fazl coaches you live.",
    sections: [
      { h2: "The smart way to learn forex trading", body: "You can learn forex trading from free content for years and still stay stuck. Guided, corrected practice is what turns theory into a real skill, and it's the core of how Shabz coaches." },
      { h2: "Learn forex trading with a real edge", body: "When you learn forex trading the right way, you build an edge you understand and trust — clean setups, defined risk and the discipline to follow your own rules." },
    ],
    learn: ["How the forex market actually works", "Currency pairs, pips and leverage explained", "Chart reading and market structure", "Your first repeatable strategy", "Risk rules that protect your capital"],
  },
  {
    slug: "forex-trading-for-beginners",
    key: "forex trading for beginners",
    img: "/forex/forex-trading-for-beginners.jpeg",
    intro:
      "Forex trading for beginners doesn't have to mean expensive mistakes. With Shabz Fazl guiding you, you start with the right foundations and skip the costly guesswork.",
    sections: [
      { h2: "Forex trading for beginners, done properly", body: "Most beginners blow their first accounts chasing hype. Forex trading for beginners should start with structure, risk and psychology — the exact order Shabz teaches so you build confidence without gambling." },
      { h2: "From beginner to consistent", body: "Forex trading for beginners is only the starting line. Shabz's coaching is designed to carry you from your very first trade all the way to calm, consistent execution." },
    ],
    learn: ["Setting up your platform the right way", "Understanding pips, lots and leverage", "Your first safe, simple strategy", "Protecting capital with strict risk rules", "Building good habits from day one"],
  },
  {
    slug: "forex-trading-strategies",
    key: "forex trading strategies",
    img: "/forex/forex-trading-strategies.jpeg",
    intro:
      "The best forex trading strategies are simple, tested and executed with discipline. Shabz Fazl helps you build strategies you actually understand and can repeat.",
    sections: [
      { h2: "Forex trading strategies that hold up", body: "Collecting forex trading strategies is easy; executing one flawlessly is hard. Shabz strips away the noise and builds a small set of clean, high-probability setups tailored to how you trade." },
      { h2: "Turning strategies into consistency", body: "Great forex trading strategies mean nothing without discipline. Coaching closes the gap between knowing a setup and executing it the same way, trade after trade." },
    ],
    learn: ["Trend-following and breakout setups", "Support, resistance and supply/demand", "Multi-timeframe confirmation", "Entry, stop and target frameworks", "Back-testing and refining your edge"],
  },
  {
    slug: "forex-day-trading",
    key: "forex day trading",
    img: "/forex/forex-day-trading.jpeg",
    intro:
      "Forex day trading rewards preparation and discipline, not adrenaline. Shabz Fazl coaches you to trade the intraday sessions with a calm, professional process.",
    sections: [
      { h2: "Forex day trading with a plan", body: "Forex day trading punishes traders who wing it. Shabz teaches you to prep watchlists, define your intraday setups and execute without the emotional swings that wreck most day traders." },
      { h2: "Sustainable forex day trading", body: "Done right, forex day trading is a repeatable business — not a casino. Coaching builds the routine, risk control and focus that make intraday trading sustainable." },
    ],
    learn: ["Session timing and volatility windows", "Intraday setups and tape reading", "Fast, disciplined risk management", "Managing screen time and focus", "Avoiding overtrading and revenge trades"],
  },
  {
    slug: "forex-swing-trading",
    key: "forex swing trading",
    img: "/forex/forex-swing-trading.jpeg",
    intro:
      "Forex swing trading lets you profit from multi-day moves without living at your screen. Shabz Fazl coaches a patient, high-conviction swing approach.",
    sections: [
      { h2: "Forex swing trading for busy traders", body: "Forex swing trading is ideal if you can't watch charts all day. Shabz teaches you to catch larger moves with fewer, higher-quality decisions and far less screen stress." },
      { h2: "Conviction in forex swing trading", body: "The hardest part of forex swing trading is holding your position through noise. Coaching builds the conviction and risk framework to let winners run." },
    ],
    learn: ["Identifying swing highs and lows", "Higher-timeframe trend alignment", "Entries that survive market noise", "Wider stops and position sizing", "Holding trades with conviction"],
  },
  {
    slug: "forex-trading-psychology",
    key: "forex trading psychology",
    img: "/forex/forex-trading-psychology.jpeg",
    intro:
      "Forex trading psychology is where most talented traders quietly fall apart. Shabz Fazl's identity-level coaching rebuilds how you show up at the charts.",
    sections: [
      { h2: "Why forex trading psychology decides everything", body: "You can know every setup and still self-sabotage. Forex trading psychology — fear, greed, revenge and hesitation — is the real reason six-figure traders stall, and it's Shabz's specialty." },
      { h2: "Rebuilding your forex trading psychology", body: "Shabz works on forex trading psychology at an identity level, so discipline and confidence become natural rather than something you force through willpower on every trade." },
    ],
    learn: ["Beating fear, greed and FOMO", "Ending revenge and impulse trading", "Building calm, repeatable routines", "Journaling for self-awareness", "Trading from a rebuilt sense of self"],
  },
  {
    slug: "price-action-forex-trading",
    key: "price action forex trading",
    img: "/forex/price-action-forex-trading.jpeg",
    intro:
      "Price action forex trading strips the charts back to what actually matters. Shabz Fazl coaches you to read raw price like a professional.",
    sections: [
      { h2: "The power of price action forex trading", body: "Indicators lag; price doesn't. Price action forex trading teaches you to read candles, structure and momentum directly, so you can trade any pair without cluttered charts." },
      { h2: "Mastering price action forex trading", body: "Price action forex trading looks simple but takes real reps to master. Shabz coaches you through live examples until reading clean price becomes second nature." },
    ],
    learn: ["Reading candlestick behaviour", "Market structure and key levels", "Break-and-retest entries", "Trading without lagging indicators", "Context, momentum and confluence"],
  },
  {
    slug: "forex-risk-management",
    key: "forex risk management",
    img: "/forex/forex-risk-management.jpeg",
    intro:
      "Forex risk management is the single skill that keeps traders in the game long enough to win. Shabz Fazl makes it the foundation of everything she coaches.",
    sections: [
      { h2: "Forex risk management comes first", body: "No edge survives poor forex risk management. Shabz teaches position sizing, stop placement and R-multiple thinking so a losing streak never ends your account." },
      { h2: "Forex risk management that scales", body: "Good forex risk management is what lets you scale size with confidence. Protect capital first, and consistent growth becomes a matter of time." },
    ],
    learn: ["Position sizing and the 1% rule", "Smart stop-loss placement", "Thinking in R-multiples", "Managing drawdowns and variance", "Scaling size without blowing up"],
  },
];

export const FOREX_PAGES = PAGES.map((p) => ({
  ...p,
  tags: buildTags(p.key),
  searchTerms: buildSearchTerms(p.key),
  title: `${p.key.replace(/\b\w/g, (c) => c.toUpperCase())} | Shabz Fazl`,
  description: `${p.intro} Message Shabz Fazl on Instagram to apply. Paid mentorship only.`,
}));

export const getForexPage = (slug) => FOREX_PAGES.find((p) => p.slug === slug);
